// extracted by mini-css-extract-plugin
export var dividerContainer = "_80-0";
export var line = "_80-1";